import HeaderBanner from './HeaderBanner';
import { VisionIcon, MissionIcon } from './Icon';

const OctopussTechnology = () => {

    return (
        <>
            <HeaderBanner heading={'Octopuss Technologies'} imagePath="assets/images/banners/technology.avif" />

            <section className="about about-1" id="about-1" style={{ marginTop: '30px' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-lg-12">
                            <div className="heading heading-11">
                                <div className="row">
                                    <div className="col-12">
                                        <p className="heading-with-border">Octopuss Technologies </p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-lg-12">
                                        <p className='octo-para'>
                                            When you choose Octopus Technologies as your web development partner, you're choosing a commitment to excellence, innovation, and unwavering support. Whether you're a startup looking to make a mark or an established business seeking digital transformation, we're here to help you thrive in the digital age.
                                        </p>
                                        <p className='octo-para'>
                                            Join us on this exciting journey. Let's create extraordinary web experiences together.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- End .col-lg-6 --> */}
                    </div>
                    {/* <!-- End .row--> */}
                </div>
                {/* <!-- End .container--> */}
            </section>
            <section className="bleezy-about-page" style={{ marginBottom: '30px', background: '#f5f1f1', paddingTop: '30px' }}>
                <div className="container">
                    <div className="row">
                        <div className='container-card about-left'>
                            <div className='mission-vision-card'>
                                <h2 className='heading-without-border'><VisionIcon></VisionIcon> OUR VISION :</h2>
                                <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                                    “Our vision is simple yet ambitious: to create exceptional web experiences that captivate, engage, and empower businesses and individuals alike. In an ever-evolving digital landscape, we strive to be at the forefront of innovation, delivering tailor-made solutions that leave a lasting impact.”
                                </p>
                            </div>
                            <div className='mission-vision-card'>
                                <h2 className='heading-without-border'><MissionIcon></MissionIcon> OUR EXPERTISE :</h2>
                                <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                                    “We specialize in harnessing the power of the latest technologies to build dynamic and user-friendly web applications. With a core focus on React.js, Node.js, and other leading-edge tools, we craft solutions that are not just visually stunning but also robust, scalable, and future-ready.”
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="about about-1" id="about-1" style={{ marginTop: '30px' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-lg-12">
                            <div className="heading heading-11">
                                <div className="row">
                                    <div className="col-12">
                                        <div className='center-heading'>
                                            <p className="heading-with-border">We Provide </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="services-section">
                <div className="services-container">
                    <div className="service-box">
                        <div className="service-header">
                            <span className="service-number">01</span>
                            <span className="service-line"></span>
                            <h3>Software Development</h3>
                        </div>
                        <p className='octo-para'>
                            Software development services help plan, design, develop, integrate,
                            test, manage and evolve software solutions. Quality-centered and
                            adherent to mature software development practices, Octopus Technologies
                            provides application development services to startups, software
                            companies, and enterprises across 7+ industries.
                        </p>
                    </div>

                    <div className="service-box">
                        <div className="service-header">
                            <span className="service-number">02</span>
                            <span className="service-line"></span>
                            <h3>Web Development</h3>
                        </div>
                        <p className='octo-para'>
                            Web development, also known as website development, refers to the tasks
                            associated with creating, building, and maintaining websites and web
                            applications that run online on a browser. It may, however, also include
                            web design, web programming, and database management.
                        </p>
                    </div>

                    <div className="service-box">
                        <div className="service-header">
                            <span className="service-number">03</span>
                            <span className="service-line"></span>
                            <h3>Mobile App Development</h3>
                        </div>
                        <p className='octo-para'>
                            Mobile application development is the process of creating software
                            applications that run on a mobile device, and a typical mobile
                            application utilizes a network connection to work with remote computing
                            resources.
                        </p>
                    </div>

                </div>
            </section>

            <section className="process-section" style={{marginBottom:'30px'}}>
                <div className="container">

                    <p className="section-subtitle">HOW WE DO IT</p>
                    {/* <h2 className="section-title">Work Process</h2> */}
                    <div className='center-heading'>
                        <p className="heading-with-border" style={{marginBottom:'30px'}}>Work Process </p>
                    </div>

                    <div className="process-wrapper">

                        <div className="process-item">
                            <div className="circle blue">01</div>
                            <h3>Requirements Gathering and Analysis</h3>
                            <p className='octo-para'>
                                Requirements are documented in detail to create a clear and
                                shared understanding of the project scope.
                            </p>
                        </div>

                        <div className="process-item">
                            <div className="circle yellow">02</div>
                            <h3>Design and Planning</h3>
                            <p className='octo-para'>
                                Planning is essential to define project milestones, allocate
                                resources, estimate costs, and create a project timeline.
                            </p>
                        </div>

                        <div className="process-item">
                            <div className="circle teal">03</div>
                            <h3>Implementation (Coding)</h3>
                            <p className='octo-para'>
                                In this phase, developers write the actual code for the software
                                based on the design specifications and requirements.
                            </p>
                        </div>

                        <div className="process-item">
                            <div className="circle dark">04</div>
                            <h3>Testing and Quality Assurance</h3>
                            <p className='octo-para'>
                                Quality assurance activities focus on validating that the software
                                meets quality standards and is ready for deployment.
                            </p>
                        </div>

                    </div>

                </div>
            </section>


        </>
    )
}

export default OctopussTechnology;